import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SuccessScreen from '@/components/ui/SuccessScreen/SuccessScreen';
import { useGetAuthApi } from '@/hooks/UseApiCalls';
import useFundContext from '@/contexts/Fund/useFundContext';
import DonationFlow from '../PublicDonation/DonationFlow';
import { DonationPageConfig } from '../PublicDonation/types';
import DonorSearchField from './DonorSearchField';
import donationStyles from '../PublicDonation/PublicDonation.module.css';

const DonationNewPage = () => {
  const { t } = useTranslation();
  const { currentFund } = useFundContext();
  const fundId = currentFund?.id;

  const { data: config } = useGetAuthApi<DonationPageConfig>(
    fundId ? `donations/page-config/${fundId}` : ''
  );

  const [flowKey, setFlowKey] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  const resetForAnother = () => {
    setSubmitted(false);
    setFlowKey((k) => k + 1);
  };

  if (!currentFund) return <h1>{t('noFundSelected')}.</h1>;

  return (
    <div className={donationStyles.page}>
      <div className={donationStyles.card}>
        {config?.logoUrl && (
          <img src={config.logoUrl} alt="" className={donationStyles.donationLogo} />
        )}
        <h1 className={donationStyles.title}>{t('donations.donateTo', { id: currentFund.id, name: currentFund.name })}</h1>

        {submitted ? (
          <div style={{ padding: '48px 0' }}>
            <SuccessScreen
              title={t('donations.success.title')}
              description={t('donations.success.description')}
              primaryButtonText={t('donations.admin.anotherDonation')}
              primaryButtonAction={resetForAnother}
            />
          </div>
        ) : config && fundId ? (
          <DonationFlow
            key={flowKey}
            config={config}
            onSuccess={() => setSubmitted(true)}
            renderDonorSearch={(applyDonor) => (
              <DonorSearchField fundId={fundId} onSelect={applyDonor} />
            )}
          />
        ) : (
          <div className={donationStyles.loaderWrapper}>
            <div className={donationStyles.spinner} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DonationNewPage;
